import {ResourceParams, resources} from "./resources";

export const defaultResourceParams: ResourceParams = resources['record-lists'];
